<template>
  <div>
    <list-header title="Promotion Services" />

    <pull-to-refresh :refreshFunction="handleRefresh">
      <!-- Services Found -->
      <div v-if="promotionServices && promotionServices.length !== 0">
        <service-item
          :items="promotionServices"
          :hidePrice="init.hideServicePrice"
          :handleItem="viewItemDetail"
          :handleItemSelection="goToMakeAppointmentForPromotionService"
        />
      </div>
      <!-- Services not found -->
      <div v-else>
        <item-not-found message="No more promotion found." />
      </div>
    </pull-to-refresh>
  </div>
</template>

<script>
import {
  defineAsyncComponent,
  markRaw
} from "vue";
import ListHeader from "@/components/ListHeader.vue";
import PullToRefresh from "@/components/PullToRefresh.vue";
import ItemNotFound from "@/components/ItemNotFound.vue";
import ServiceItem from "../components/ServiceItem.vue";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import { openModal, closeModal } from "@/store/modal";

export default {
  name: "Promotion",
  components: {
    ListHeader,
    PullToRefresh,
    ItemNotFound,
    ServiceItem,
  },
  computed: {
    ...mapGetters(
      [
        "init",
        "promotionServices",
      ]
    ),
  },
  methods: {
    async handleRefresh() {
      // Fetch data parallely
      await Promise.all([(async () => await this.getPromotionServices())()]);
    },
    goToMakeAppointmentForPromotionService(service) {
      if (!service.futurePromotion) {
        this.goToMakeAppointment(service);
      } else {
        useToast().warning("Promotion not started.");
      }
    },
    goToMakeAppointment(service) {
      const serviceDetails = {
        description: service.description,
        id: service.id,
        imageURL: service.image,
        name: service.name,
        type: service.type,
        processingTime: service.service.processingTime,
        formatProcessingTime: service.service.formatProcessingTime,
        price: service.price,
        promotion: service.promotion,
        promotionId: service.service.promotionId,
        promotionPrice: service.service.promotionPrice,
        promotionStartDate: service.service.startDate,
        promotionEndDate: service.service.endDate,
        originalPrice: service.originalPrice,
        salePrice: service.salePrice,
        prepaidItemId: 0,
        sectionName: service.productSection?.name,
        categoryName: service.productCategory?.name,
      };
      sessionStorage.setItem("serviceDetails", JSON.stringify(serviceDetails));
      this.$router.push("/make-appointment");
    },
    viewItemDetail(service) {
      openModal(
        {
          id: "expandableListItemDetailModal",
        },
        markRaw(defineAsyncComponent(() => import("@/components/ExpandableListItemDetail.vue"))),
        {
          image: service.image,
          processingTime: service.service.formatProcessingTime,
          name: service.name,
          description: service.description,
          originalPrice: service.futurePromotion ? service.futureOriginalPrice : service.originalPrice,
          salePrice: service.futurePromotion ? service.futureSalePrice : service.salePrice,
          section: service.productSection?.name,
          category: service.productCategory?.name,
          promotion: service.promotion,
          futurePromotion: service.futurePromotion,
          hidePrice: this.init.hideServicePrice,
        },
        {},
        [
          {
            text: 'Book',
            class: 'scss-blue-button',
            clickFn: () => {
              if (!service.futurePromotion) {
                this.goToMakeAppointment(service);
                closeModal();
              } else {
                useToast().warning("Promotion not started.");
              }
            }
          },
          {
            text: 'Close',
            clickFn: () => {
              closeModal();
            }
          }
        ]
      );
    },
    ...mapActions(["getPromotionServices"]),
  },
};
</script>

<style lang="scss" scoped>
.style-checkbox {
  font-size: 20px;
}

.style-content {
  width: 90%;
  margin: 0 auto 0 auto;
  margin-bottom: 70px;
}

.style-action-container {
  margin: 0 auto 0 auto;
  padding-top: 5px;
  max-width: 510px;
  border: 1px solid $border-light-grey;
  background-color: white;
  z-index: 5;
}
</style>
